export default __webpack_public_path__ + "static/media/vivivault.28033adc.png";